/**
 * API Configuration - Centralized Single Source of Truth
 * Uses relative paths that nginx will proxy to backend services
 */

export interface ApiEndpoints {
  authApi: string;
  schoolApi: string;
  learningApi: string;
  cdnBaseUrl: string;
}

// Centralized configuration - Use relative paths for nginx proxy
const getApiEndpoints = (): ApiEndpoints => {
  // Use relative paths that nginx will proxy to backend services
  const authApi = '/api/auth';
  const schoolApi = '/api/school';
  const learningApi = '/api/learning';
  const cdnBaseUrl = '/api/cdn';

  return {
    authApi,
    schoolApi,
    learningApi,
    cdnBaseUrl
  };
};

export const API_ENDPOINTS = getApiEndpoints();
